export const formatNewsDate = (date: string | undefined, language: string) => {
  if (!date) return ''

  return new Intl.DateTimeFormat(language === 'bg' ? 'bg-BG' : 'en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  }).format(new Date(`${date}T12:00:00`))
}
